module.exports = "/dist/654cb4d3907ce76ae06546007e658318.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100.woff
// module id = 144
// module chunks = 0